import { lang } from '@umu/ukit-lang';
/**
 * @description
 */

import './pageQrCodeDialog.scss';

import React from 'react';

import { components, services } from 'common';
const { If, PreImg, Dialog, DialogHeader, DialogBody } = components;
const { getModuleData } = services;
import { now } from '@umu/umu-util';
import { $location } from '@umu/umu-dom';

interface IProps {
    title?: string;
    subTitle?: string;
    clsName?: string;
    show: boolean;
    onClose(): void;
}

export default function PageQrCodeDialog(props: IProps) {
    const render = () => {
        const title = props.title || lang('扫一扫，用微信打开');
        const info = (
            <div className="qr">
                <div className="img">
                    <PreImg>
                        <img
                            src={
                                '//' +
                                getModuleData('siteHost') +
                                '/qrc/?' +
                                now() +
                                '&type=link&param=' +
                                encodeURIComponent($location.href)
                            }
                            alt=""
                        />
                    </PreImg>
                </div>
            </div>
        );

        const clsName = props.clsName || '';

        return (
            <Dialog
                show={props.show}
                hasMask={true}
                className={'page-qrcode-dialog ' + clsName}
                canClose={true}
                close={props.onClose}
            >
                <DialogHeader>
                    <div className="title">{title}</div>
                </DialogHeader>
                <DialogBody>
                    <If condition={!!props.subTitle}>
                        <p className="qr-sub-title">{props.subTitle}</p>
                    </If>
                    <div className="info">{info}</div>
                </DialogBody>
            </Dialog>
        );
    };
    return render();
}
